/* eslint-disable @typescript-eslint/ban-types */
import { message } from 'antd'
import { initGtCaptcha } from './captcha'

interface IOptions {
  onReady: Function
  changeCaptchaToImage: Function
  onSuccess: (result: any) => void
}

const onInitSuccess = (gt: any, ref: HTMLDivElement, onReady: Function, onSuccess: Function, changeCaptchaToImage: Function) => {
  gt.onReady(() => {
    onReady()
    gt.appendTo(ref as any)
  }).onSuccess(() => {
    const result = gt.getValidate()
    onSuccess({ ...result, gt })
  }).onError((e) => {
    gt.destroy()
    // 当h5页面切到后台运行，js计数器无法计数 或者 当页面被挂起，长时间不操作，50分钟后，验证流会被销毁，后端会返回error_21,需要将原验证销毁，重新初始化
    if (JSON.stringify(e) === '{}' || !e.code || e.code === 'error_21' || e.code === 'error_12' || e.code === 'error_01') {
      if (e.code === 'error_12') {
        message.error('尝试次数过多，请重新验证')
      }
      if (e.code === 'error_01') {
        message.error('刷新次数过多，请重新验证')
      }
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      initSliderCaptcha(ref, { onSuccess, onReady, changeCaptchaToImage } as IOptions)
    } else {
      changeCaptchaToImage()
    }
  })
}

export const initSliderCaptcha = (ref, { onSuccess, onReady, changeCaptchaToImage }: IOptions) => {
  initGtCaptcha((gt) => onInitSuccess(gt, ref, onReady, onSuccess, changeCaptchaToImage), () => changeCaptchaToImage())
}
